export default {
  'tournament.hallId': 'Hall ID',
  'tournament.hallName': 'Hall Name',
  'tournament.initialChips': 'Initial Chips',
  'tournament.timeLimit': 'Time Limit',
  'tournament.playerLimit': 'Player Limit',
  'tournament.ticket': 'Ticket',
  'tournament.game': 'Game',
  'tournament.matchMode': 'Match Mode',

  'tournament.balance': 'Balance',
  'tournament.coverImage': 'Cover Image',
  'tournament.createTime': 'Create Time',
  'tournament.updateTime': 'Update Time',
  'tournament.operation': 'Operate',
  'tournament.bonusTemplate': 'Prize Template',
  'tournament.hallParameters': 'Lobby Parameter',
  'tournament.input': 'Please enter',
  'tournament.hallNameTranslation': 'Lobby Name Translation',
  'tournament.prizePool': 'Prize Pool',
  'tournament.robotParticipationSwitch': 'Robot Switch',
  'tournament.hallType': 'Lobby Type',
  'tournament.bonusExchangeMethod': 'Prize Redemption Mode',
  'tournament.exchangeCodeValidityPeriod': 'Redemption Valid Period',
  'tournament.bonusExchangeCopyTemplate': 'Redemption Copywriting Template',
  'tournament.globalConfig': 'Global Config',
  'tournament.openGlobalConfig': 'Open Global Config',
  'tournament.homeHallCardUITemplate': 'Homepage Lobby UI Template',
  'tournament.modify': 'Edit',
  'tournament.matchModeBetAmount': 'Competition Mode: Bet Amount',
  'tournament.matchModeBalance': 'Competition Mode: Balance',
  'tournament.language': 'Language',
  'tournament.enterTranslation': 'Please enter transation of {lang}',
  'tournament.selectGame': 'Select game',
  'tournament.clickUpload': 'Click to upload',
  'tournament.bonusSettings': 'Reward Settings',
  'tournament.activeLobbies': 'lobbies are active',
  'tournament.chinese': 'Chinese',
  'tournament.english': 'English',
  'tournament.tagalog': 'Tagalog',
  'tournament.vietnamese': 'Vietnamese',
  'tournament.submitLogic': 'Submit Logic',
  'tournament.uploadImageTip': 'Only upload jpg/png/webp/gif files',
  'tournament.uploadErrorMsg': 'Only upload jpg/png/jpeg/webp files',
  'tournament.bonusTemplateSheet': 'Bonus Template',
  'tournament.templateFileName': 'Bonus Settings Template.xlsx',
  'tournament.rankReference': 'Rank (Reference Only)',
  'tournament.amount': 'Amount',
  'tournament.firstPlace': '1st Place',
  'tournament.secondPlace': '2nd Place',
  'tournament.emptyTemplateError': 'Template content is empty or format is incorrect',
  'tournament.importSuccess': 'Successfully imported',
  'tournament.playerCountMustBeGreaterThanZero': 'Player count must be greater than 0',
  'tournament.timeLimitMustBeGreaterThanZero': 'Time limit must be greater than 0',
  'tournament.playerLimitMustBeGreaterThanZero': 'Player limit must be greater than 0',
  'tournament.ticketMustBeGreaterThanZero': 'Ticket must be greater than 0',

  'tournament.uploadImageRequired': 'Please upload image',
  'tournament.enterSortNumber': 'Please enter sort number',
  'tournament.downloadImportTemplate': 'Download Import Template',
  'tournament.import': 'Import',
  'tournament.addItem': 'Add',
  // 「47th Place」在 76px 的 label 列里放不下，英文用更短的「No.47」
  'tournament.place': 'No.{num}',
  'tournament.enterAmount': 'Please enter amount',
  'tournament.homeHallCardUITemplateTitle': 'Homepage Lobby Card UI Template:',
  'tournament.homeHallCardUITemplateLabel': 'Homepage Lobby Card UI Template',
  'tournament.matchRulesCopy': 'Match Rules Copy',
  'tournament.matchModeBetAmountTitle': 'Competition Mode: Bet Amount',
  'tournament.matchModeBalanceTitle': 'Competition Mode: Balance',
  'tournament.languageLabel': 'Language',
  'tournament.enterLanguageTranslation': 'Please enter {lang} translation',
  'tournament.specifyGame': 'Specify Game',
  'tournament.selected': 'Selected',
  'tournament.minutes': 'minutes',
  'tournament.people': 'people',
  'tournament.tickets': 'tickets',
  'tournament.prizePoolMustBeGreaterThanZero': 'Prize pool must be greater than 0',
  'tournament.enterHallName': 'Please enter hall name',
  'tournament.selectHallNameTranslation': 'Please select hall name translation',
  'tournament.redemptionCode': 'Redemption Code',
  'tournament.days': 'days',
  'tournament.hours': 'hours',
  'tournament.daysRange': '0-365 days',
  'tournament.open': 'Open',
  'tournament.normal': 'Normal',
  'tournament.demo': 'Demo',
  'tournament.cash': 'Cash',
  'tournament.hoursRange': '0-24 hours',
  'tournament.minutesRange': '0-60 minutes',
  'tournament.enterAccountToQuery': 'Enter account to query before setting tickets',
  'tournament.existingTickets': 'Existing Tickets',
  'tournament.operationType': 'Operation Type',
  'tournament.increase': 'Increase',
  'tournament.deduct': 'Deduct',
  'tournament.ticketChangeAmount': 'Ticket Change Amount',
  'tournament.enterTicketChangeAmount': 'Please enter ticket change amount',
  'tournament.ticketChangeAmountMustBeGreaterThanZero':
    'Ticket change amount must be greater than 0',
  'tournament.dayTicketDispatch': 'Daily, dispatch all members',
  'tournament.dayTicketDispatchTickets': 'per day',
  'tournament.rankLimitSwitch': 'Rank Limit Switch',

  'tournament.robotRankLimitError':
    'When the rank limit mechanism is enabled, the robot switch must also be enabled',

  'tournament.lobbyId': 'Lobby ID',
  'tournament.roomId': 'Room ID',
  'tournament.startTime': 'Start Time',
  'tournament.settleTime': 'Settle Time',
  'tournament.roomStatus': 'Room Status',
  'tournament.roomStatusNotStarted': 'Not Started',
  'tournament.roomStatusInProgress': 'In Progress',
  'tournament.roomStatusFinished': 'Finished',
  'tournament.roomStatusSettling': 'Settling',
  'tournament.roomStatusSettled': 'Settled',
  'tournament.participantList': 'Participant List',
  'tournament.winnerList': 'Winner List',
  'tournament.accountId': 'Account ID',
  'tournament.parentAccountId': 'Parent Account ID',
  'tournament.deviceCode': 'Device Code',
  'tournament.deviceType': 'Device Type',
  'tournament.loginIp': 'IP Login',
  'tournament.address': 'Address',
  'tournament.phoneNumber': 'Phone Number',
  'tournament.score': 'Score',
  'tournament.rank': 'Rank',
  'tournament.lastLoginTime': 'Last Login Time',
  'tournament.accountRegisterTime': 'Account Register Time',
  'tournament.roomRegisterTime': 'Room Register Time',
  'tournament.participantListExportFileName': 'Participant List_{date}',
  'tournament.winnerListExportFileName': 'Winner List_{date}',

  'tournament.password': 'Password',
  'tournament.enterPassword': 'Please enter password',
  'tournament.passwordRegex':
    ' 1-10 letters or numbers, users need to enter the correct password to participate in the tournament',

  // Ticket Record
  'tournament.ticketRecord': 'Ticket Record',
  'tournament.ticketBefore': 'Before',
  'tournament.ticketAfter': 'After',
  'tournament.ticketChangeValue': 'Change Value',
  'tournament.changeType': 'Change Type',
  'tournament.changeReason': 'Change Reason',
  'tournament.entryCondition': 'Entry Condition',
  'tournament.coinRank': 'Coin-Rank',
  'tournament.coinSplit': 'Coin-Split',
  'tournament.enterCoin': 'Please enter coins',
  'tournament.enterTicketCount': 'Please enter tickets',
  'tournament.coinRange': 'Please enter an integer between 1 and 999999',
  'tournament.rake': 'Rake',
  'tournament.rakeRange': 'Please enter an integer between 0 and 999999',
  'tournament.robot': 'Robot',
  'tournament.realPlayer': 'Real Player',
  'tournament.enterRank': 'Please enter rank',
  'tournament.totalCoin': 'Total Coins',
  'tournament.totalCoinRange': 'Please enter an integer between 0 and 999999',
  'tournament.coinDistribution': 'Coin Distribution',
  'tournament.robotDistribution': 'Robot Distribution',
  'tournament.robotCount': 'Robot Count',
  'tournament.enterRobotCount': 'Please enter robot count',
  'tournament.rankAtLeastOne': 'Configure at least one rank',
  'tournament.rankRangeOrder':
    'Rank ranges must satisfy: 1 <= start <= end < next start, and not exceed the player limit',
  'tournament.rankStartAfterPrev': 'Start must be greater than the previous end',
  'tournament.rankEndAfterStart': 'End must be greater than or equal to start',
  'tournament.rankExceedLimit': 'Rank must not exceed the player limit',
  'tournament.coinDistOrder': 'Coin distribution must satisfy: 0 <= min <= max <= total coins',
  'tournament.coinDistExceed': 'Rank count x max coins must not exceed total coins',
  'tournament.robotCountExceed': 'Robot count must not exceed the number of ranks in this range',
  'tournament.robotTotalExceed': 'Total robots must not exceed the player limit',
  'tournament.setPlayerLimitFirst': 'Please fill in the player limit first',
  'tournament.rankExceedPlayerLimit': 'Rank count cannot exceed the player limit',
  'tournament.roomConsumption': 'Room Consumption',
  'tournament.ticketUsed': 'Tickets Used',
  'tournament.coinUsed': 'Coins Used',
  'tournament.coinRake': 'Coin Rake',
  'tournament.coinAward': 'Coins Awarded',
  'tournament.winner': 'Winner',
  'tournament.participantSummary': '{participants} participants',
  'tournament.winnerSummary': '{winners} winners',
};
